import { indexRedirectTarget } from '../utils/indexRedirect';

globalThis.location.replace(indexRedirectTarget(globalThis.location.search || '', globalThis.location.hash || ''));
